module.exports = __webpack_public_path__ + "img/daichao1.a63ff385.png";